// @flow

export const SET_USER_IDENTITY = 'SET_USER_IDENTITY';



// WEBPACK FOOTER //
// ./app/CaptureFeedback/user/actionTypes.js